import { memo, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import useSuffixMarginLeft from "app/utils/hooks/useElementHasMinLines";

const PaymentCreditsTitleTypography = ({ text, suffix, className }) => {
	const textRef = useRef(null);
	const suffixRef = useRef(null);
	const shouldAddIconMargin = useSuffixMarginLeft(textRef, suffixRef);

	return (
		<Typography
			variant={TYPOGRAPHY_VARIANTS.LARGE}
			isBold
			component="h3"
			className={classNames(
				"payment-credits__title",
				shouldAddIconMargin && "payment-credits__title--icon-margin",
				className
			)}
		>
			<span ref={textRef} className="payment-credits__title-text">
				{text}
			</span>
			{suffix && (
				<span ref={suffixRef} className="payment-credits__title-suffix">
					{suffix}
				</span>
			)}
		</Typography>
	);
};

PaymentCreditsTitleTypography.propTypes = {
	text: PropTypes.node.isRequired,
	suffix: PropTypes.node,
	className: PropTypes.string,
};

export default memo(PaymentCreditsTitleTypography);
